import React, {useEffect} from 'react'


const PageNoteFound = (props)=>{
  return <h3>Sorry something went wrong</h3>
}

export default PageNoteFound
